import { Shield, Lock, Award, Users } from "lucide-react";

export const TrustBadges = () => {
  const badges = [
    {
      icon: Shield,
      title: "GDPR Compliant",
      description: "Your data is protected",
    },
    {
      icon: Lock,
      title: "SSL Encrypted",
      description: "Bank-level security",
    },
    {
      icon: Award,
      title: "SOC 2 Certified",
      description: "Trusted by enterprises",
    },
    {
      icon: Users,
      title: "10,000+ Users",
      description: "Growing community",
    },
  ];

  return (
    <section className="py-12 bg-secondary/10" aria-labelledby="trust-heading">
      <h2 id="trust-heading" className="sr-only">Trusted by Industry Leaders</h2>
      <div className="container mx-auto px-4">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {badges.map((badge, index) => {
            const Icon = badge.icon;
            return (
              <div
                key={index}
                className="flex items-center gap-4 p-4 bg-background rounded-lg border"
              >
                <div className="p-3 bg-primary/10 rounded-full">
                  <Icon className="h-6 w-6 text-primary" aria-hidden="true" />
                </div>
                <div>
                  <h3 className="font-semibold">{badge.title}</h3>
                  <p className="text-sm text-muted-foreground">
                    {badge.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
